import React, { type ReactNode } from 'react';
import { motion } from 'framer-motion';
export function FadeIn({
  children,
  delay = 0,
  className = ''
}: {
  children: ReactNode;
  delay?: number;
  className?: string;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-135">
      {children}
    </motion.div>;
}
export function Button({
  children,
  onClick,
  className = '',
  variant = 'primary'
}: {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  variant?: 'primary' | 'secondary';
}) {
  const baseStyle = 'inline-flex items-center justify-center px-8 py-4 text-lg font-semibold rounded-full transition-all duration-300 shadow-lg hover:shadow-xl';
  const variants = {
    primary: 'bg-brand-gold text-white hover:bg-[#b39240]',
    secondary: 'bg-brand-teal text-brand-cream hover:bg-[#0a2a2b]'
  };
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} onClick={onClick} className={`${baseStyle} ${variants[variant]} ${className}`} data-id="element-136">
      {children}
    </motion.button>;
}